import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getAccountVouchers } from '@arrived/api_v2';
import { Rewards } from '@arrived/models';

import { UseQueryResult } from '../queries.utils';
import { voucherKey, voucherAppliedKey, voucherUnusedKey } from './rewards.keys';
import { getOrCreateRewardsAccountId } from './utils/getOrCreateRewardsAccountId';

export function useGetVouchersQuery(userInfo: Rewards.RewardsUserInfo): UseQueryResult<Rewards.VoucherSearchResponse> {
  const queryClient = useQueryClient();
  return useQuery(
    voucherKey,
    async () => {
      const rewardsAccountUuid = await getOrCreateRewardsAccountId(queryClient, userInfo);
      return getAccountVouchers(rewardsAccountUuid);
    },
    {
      onSettled: (data, error) => {
        queryClient.setQueryData(
          voucherAppliedKey,
          data?.vouchers?.filter((voucher) => voucher.state === 'APPLIED') || []
        );
        queryClient.setQueryData(
          voucherUnusedKey,
          data?.vouchers?.filter((voucher) => voucher.state === 'CREATED') || []
        );

        data?.vouchers?.forEach((voucher) => {
          queryClient.setQueryData([voucherKey, voucher.uuid], voucher);
        });
      },
    }
  );
}
